import { createSlice, createAsyncThunk, createEntityAdapter } from "@reduxjs/toolkit";
import { request } from "@/utils/api";

const appliedRateAdapter = createEntityAdapter({
    selectId: (rate) => rate._id,
    sortComparer: (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
});

export const upsertAppliedRate = createAsyncThunk(
    "appliedRate/upsert",
    async ({ rates, customerId }, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append("rates", rates);  // Ensure correct format
            formData.append("customerId", customerId);

            const response = await request({
                endpoint: "/admin/customer/upsertRates",
                method: "POST",
                body: formData,
                headers: { "Content-Type": "multipart/form-data" }, // Ensure proper headers
            });

            if (!response.success || typeof response.data.upsertCount !== "number") {
                return rejectWithValue(response.error || "Failed to upsert rates");
            }

            return response.data; // Return relevant response data
        } catch ({ error }) {
            return rejectWithValue(error.message || "Failed to upsert rates");
        }
    }
);

const appliedRateSlice = createSlice({
    name: "appliedRate",
    initialState: appliedRateAdapter.getInitialState({
        loading: false,
        error: null,
    }),
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(upsertAppliedRate.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(upsertAppliedRate.fulfilled, (state, action) => {
                state.loading = false;
                appliedRateAdapter.upsertOne(state, { ...action.payload, id: new Date().toISOString() });
            })
            .addCase(upsertAppliedRate.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default appliedRateSlice.reducer;
export const {
    selectAll: selectAllAppliedRates,
    selectById: selectAppliedRateById,
    selectIds: selectAppliedRateIds,
} = appliedRateAdapter.getSelectors((state) => state.appliedRate);
